import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const printParcelPackingSlips = {
  name: "printParcelPackingSlips" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    workstationId: z.string().optional(),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    templateId: z.string().optional(),
  }),
  output: z.object({ url: z.string() }),
};
